/**
 * @generated SignedSource<<c4d50645b634bde7b71fc6e87ce8f91f>>
 * @relayHash ebdb3c83478a0febad213c0d0c5d0338
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8a0d1407b5ab19a4145ae8260858ede976c05eb6eab7abab7555c4d0cc53792b

import type { ConcreteRequest } from 'relay-runtime';
export type PopupPageCardViewWithAISnippetSpaceHoverPageCardQuery$variables = {
  id: string;
};
export type PopupPageCardViewWithAISnippetSpaceHoverPageCardQuery$data = {
  readonly singleContent: {
    readonly editorVersion: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null | undefined;
        readonly key: string | null | undefined;
        readonly value: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly emoji: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null | undefined;
        readonly key: string | null | undefined;
        readonly value: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly excerpt: string;
    readonly history: {
      readonly createdBy: {
        readonly accountId?: string | null | undefined;
        readonly displayName: string | null | undefined;
        readonly profilePicture: {
          readonly path: string;
        } | null | undefined;
      } | null | undefined;
      readonly ownedBy: {
        readonly accountId?: string | null | undefined;
        readonly displayName: string | null | undefined;
        readonly profilePicture: {
          readonly path: string;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
    readonly likes: {
      readonly count: number | null | undefined;
    } | null | undefined;
    readonly links: {
      readonly editui: string | null | undefined;
      readonly webui: string | null | undefined;
    } | null | undefined;
    readonly metadata: {
      readonly comments: {
        readonly commentsCount: number | null | undefined;
      } | null | undefined;
      readonly currentuser: {
        readonly favourited: {
          readonly isFavourite: boolean | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly lastModifiedDate: string | null | undefined;
    };
    readonly space: {
      readonly alias: string | null | undefined;
      readonly id: string | null | undefined;
      readonly key: string | null | undefined;
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly status: string | null | undefined;
    readonly subType: string | null | undefined;
    readonly title: string | null | undefined;
    readonly type: string | null | undefined;
    readonly version: {
      readonly by: {
        readonly accountId?: string | null | undefined;
        readonly displayName: string | null | undefined;
        readonly profilePicture: {
          readonly path: string;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type PopupPageCardViewWithAISnippetSpaceHoverPageCardQuery = {
  response: PopupPageCardViewWithAISnippetSpaceHoverPageCardQuery$data;
  variables: PopupPageCardViewWithAISnippetSpaceHoverPageCardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "title"
},
v4 = {
  "kind": "ScalarField",
  "name": "type"
},
v5 = {
  "kind": "ScalarField",
  "name": "subType"
},
v6 = {
  "kind": "ScalarField",
  "name": "status"
},
v7 = {
  "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    },
    {
      "kind": "ScalarField",
      "name": "editui"
    }
  ]
},
v8 = {
  "kind": "ScalarField",
  "name": "key"
},
v9 = [
  {
    "concreteType": "JsonContentProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v2/*: any*/),
      (v8/*: any*/),
      {
        "kind": "ScalarField",
        "name": "value"
      }
    ]
  }
],
v10 = {
  "alias": "editorVersion",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "editor"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": "properties(key:\"editor\")"
},
v11 = {
  "alias": "emoji",
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "emoji-title-published",
        "emoji-title-draft"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"])"
},
v12 = {
  "args": [
    {
      "kind": "Literal",
      "name": "length",
      "value": 372
    }
  ],
  "kind": "ScalarField",
  "name": "excerpt",
  "storageKey": "excerpt(length:372)"
},
v13 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
      "kind": "LinkedField",
      "name": "currentuser",
      "plural": false,
      "selections": [
        {
          "concreteType": "FavouritedSummary",
          "kind": "LinkedField",
          "name": "favourited",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isFavourite"
            }
          ]
        }
      ]
    },
    {
      "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
      "kind": "LinkedField",
      "name": "comments",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "commentsCount"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    }
  ]
},
v14 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v15 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v16 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v17 = [
  (v14/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/)
],
v18 = {
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v8/*: any*/),
    {
      "kind": "ScalarField",
      "name": "alias"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    }
  ]
},
v19 = {
  "concreteType": "LikesResponse",
  "kind": "LinkedField",
  "name": "likes",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "count"
    }
  ]
},
v20 = [
  {
    "kind": "ScalarField",
    "name": "__typename"
  },
  (v14/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "PopupPageCardViewWithAISnippetSpaceHoverPageCardQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          {
            "concreteType": "History",
            "kind": "LinkedField",
            "name": "history",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "createdBy",
                "plural": false,
                "selections": (v17/*: any*/)
              },
              {
                "kind": "LinkedField",
                "name": "ownedBy",
                "plural": false,
                "selections": (v17/*: any*/)
              }
            ]
          },
          (v18/*: any*/),
          (v19/*: any*/),
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": (v17/*: any*/)
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PopupPageCardViewWithAISnippetSpaceHoverPageCardQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          {
            "concreteType": "History",
            "kind": "LinkedField",
            "name": "history",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "createdBy",
                "plural": false,
                "selections": (v20/*: any*/)
              },
              {
                "kind": "LinkedField",
                "name": "ownedBy",
                "plural": false,
                "selections": (v20/*: any*/)
              }
            ]
          },
          (v18/*: any*/),
          (v19/*: any*/),
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": (v20/*: any*/)
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "ebdb3c83478a0febad213c0d0c5d0338",
    "id": "8a0d1407b5ab19a4145ae8260858ede976c05eb6eab7abab7555c4d0cc53792b",
    "metadata": {},
    "name": "PopupPageCardViewWithAISnippetSpaceHoverPageCardQuery",
    "operationKind": "query",
    "text": "query PopupPageCardViewWithAISnippetSpaceHoverPageCardQuery($id:ID!){singleContent(id:$id){id,title,type,subType,status,links{webui,editui},editorVersion:properties(key:\"editor\"){nodes{id,key,value}},emoji:properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"]){nodes{id,key,value}},excerpt(length:372),metadata{currentuser{favourited{isFavourite}},comments{commentsCount},lastModifiedDate},history{createdBy{__typename,profilePicture{path},displayName,...on KnownUser{accountId}},ownedBy{__typename,profilePicture{path},displayName,...on KnownUser{accountId}}},space{id,key,alias,name},likes{count},version{by{__typename,profilePicture{path},displayName,...on KnownUser{accountId}}}}}"
  }
};
})();

(node as any).hash = "f109efa4dac01c6b97a01fe95c90ba72";

export default node;
